import React, { useEffect, useState, useRef } from "react";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import Appointments from "./components/Appointments";
import WorkingHours from "./components/WorkingHours";
import Schedule from "./components/ScheduleV2";
import Clients from "./components/Clients";
import Settings from "./components/Settings";
import FilterButton from "./components/ScheduleFilter";
import axios from "axios";
import "./App.css";
import HamburgerMenu from "./components/HamburgerMenu";

const domain = "bunnyklawz.us.auth0.com";
const clientId = "Gw9ZJp5ibcQ0mcQEcru14FwdRIUL2hxT";

const API_BASE = "https://bunny-klawz.uc.r.appspot.com";

const Dashboard = () => {
  const { user, logout } = useAuth0();
  const [activeTab, setActiveTab] = useState("Schedule");
  const [appointments, setAppointments] = useState([]);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const [apptRes, hoursRes] = await Promise.all([
        axios.get(`${API_BASE}/appointments`),
        axios.get(`${API_BASE}/working-hours`)
      ]);

      setAppointments(apptRes.data);
      setFilteredAppointments(apptRes.data);

    };

    fetchData();
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const tabs = [
    "Schedule",
    "Appointments",
    "Working Hours",
    "Clients",
    "Settings"
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "Schedule":
        return <Schedule appointments={appointments} setAppointments={setAppointments} filteredAppointments={filteredAppointments} setFilteredAppointments={setFilteredAppointments} />;
      case "Working Hours":
        return <WorkingHours />;
      case "Appointments":
        return <Appointments isOpen={isOpen} setIsOpen={setIsOpen} menuRef={menuRef} />;
      case "Clients":
        return <Clients />;
      case "Settings":
        return <Settings />;
      default:
        return null;
    }
  };

  return (
    <div className="App">
      <HamburgerMenu activeTab={activeTab} setActiveTab={setActiveTab} logout={logout} tabs={tabs} />
      {activeTab === "Schedule" && <FilterButton appointments={appointments} setFilteredAppointments={setFilteredAppointments} isOpen={isOpen} setIsOpen={setIsOpen} menuRef={menuRef} />}
      <div className="Greeting">
        <div>
          <img className="logo" src="/images/LoadingIntroBunny.png" alt="BunnyKlawz Logo" />
          <h2 className="text-xl font-bold">Hello {user?.name}!</h2>
        </div>
        <button onClick={() => logout({ returnTo: window.location.origin })}>
          Logout
        </button>
      </div>
      <div className="Navigation">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={activeTab === tab ? "active" : ""}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className="PageContent">
        {renderContent()}
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Auth0Provider domain={domain} clientId={clientId} authorizationParams={{ redirect_uri: window.location.origin }}>
      <AuthWrapper />
    </Auth0Provider>
  );
};

const AuthWrapper = () => {
  const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0();

  if (isLoading) return <div>Loading...</div>;
  if (!isAuthenticated) {
    loginWithRedirect();
    return <div>Redirecting...</div>;
  }

  return <Dashboard />;
};

export default App;